import { Card } from 'antd';
import styled from 'styled-components';

export const StyledCard = styled(Card)`
    .ant-card-body {
        padding-block: 8px;
        box-shadow: rgba(0, 0, 0, 0.15) 0px 0px 18px 8px;
    }
`;
